import InventoryView from './InventoryView';

export default InventoryView;



// WEBPACK FOOTER //
// ./src/views/pages/InventoryView/index.js